var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaIcPreprocessingOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#00BF00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0117 8.37978C11.2215 8.37978 11.3915 8.20973 11.3915 7.99997V7.99997C11.3915 7.7902 11.2215 7.62015 11.0117 7.62015L8.3799 7.62015V4.98836C8.3799 4.7786 8.20985 4.60855 8.00008 4.60855V4.60855C7.79032 4.60855 7.62027 4.7786 7.62027 4.98836V7.62015H4.98848C4.77871 7.62015 4.60867 7.7902 4.60867 7.99997V7.99997C4.60867 8.20973 4.77872 8.37978 4.98848 8.37978H7.62027L7.62027 11.0116C7.62027 11.2213 7.79032 11.3914 8.00008 11.3914V11.3914C8.20985 11.3914 8.3799 11.2213 8.3799 11.0116V8.37978H11.0117Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(8 2.34314) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaIcPreprocessingOn);
export default __webpack_public_path__ + "static/media/pa_ic_preprocessing_on.5cca58a37b8b882b7b6d6b558a1032eb.svg";
export { ForwardRef as ReactComponent };